import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledDiv = styled.div`
  ${({ $shadow }) => $shadow ? 'box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);' : null }
  padding: 0px;
  margin: 0px;
  background-color: #fff;
  overflow: auto;
  width: 100%;
`;


const Header = styled.header`
  background-color: ${({ headercolour }) => headercolour };
  padding: 20px;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  color: ${({ textcolour }) => textcolour };
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;


const Content = styled.div`
  padding:10px;
  flex-grow: 1;
  width: 100%;
  min-width: 250px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;


const Card = ({ label, children, headercolour = '#474D68', headerTextColour = '#fff', shadow = true  }) => {
  return (
    <StyledDiv $shadow={shadow}>
      <Header headercolour={headercolour} textcolour={headerTextColour}>{label}</Header>
      <Content>{children}</Content>
    </StyledDiv>
  );
};

Card.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  headercolour: PropTypes.string,
  headerTextColour: PropTypes.string,
  shadow: PropTypes.bool,
};

export const TabbedCard = ({ label, children, headercolour = '#474D68', headerTextColour = '#fff', tabController = null, shadow = true }) => {
  return (
    <StyledDiv $shadow={shadow}>
      <Header headercolour={headercolour} textcolour={headerTextColour}>{label}</Header>
      {tabController}
      <Content>
        {children}
      </Content>
    </StyledDiv>
  );
};

TabbedCard.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  headercolour: PropTypes.string,
  headerTextColour: PropTypes.string,
  tabController: PropTypes.node,
  shadow: PropTypes.bool,
};

export default Card;